/** Metadata remains useful when historical reading totals are unavailable. */
export function deviceLastSeen(device) {
  return device?.last_reading_at ?? device?.last_seen_at;
}

export function deviceReadingsCount(device) {
  if (device?.readings_count_available === false) return null;
  return device?.readings_count ?? null;
}
